module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      chrome: _vm.isChrome, desktop: _vm.isDesktop
    },
    attrs: {
      "id": "app"
    }
  }, [_c('app-header'), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246dfbf3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 33
// module chunks = 1